import React, { Component } from 'react';
import { ArrowLeft, Phone, MessageSquare, Calendar, Package, User, Building2, Clock, Search, FileText, Loader, ChevronLeft, ChevronRight, Filter } from 'lucide-react';
import axios from 'axios';
import Cookies from "universal-cookie";
import moment from 'moment-timezone';
import host from "./host";
const cookies = new Cookies();

// Add CSS animations
const style = document.createElement('style');
style.textContent = `
    @keyframes pulse {
        0%, 100% {
            box-shadow: 0 10px 30px rgba(59, 130, 246, 0.4);
        }
        50% {
            box-shadow: 0 15px 40px rgba(59, 130, 246, 0.6);
        }
    }
    
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;
document.head.appendChild(style);

class OrderDetailsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
            showModal: false,
            selectedStatus: '',
            postponeDate: '',
            orders: [],
            filteredOrders: [],
            allOrders: [], // لحفظ جميع الطلبات
            loading: true,
            error: null,
            currentStatus: 'لايرد',
            selectedOrderId: null,
            // Pagination states
            currentPage: 1,
            itemsPerPage: 10,
            totalOrders: 0,
            // Group by states
            selectedCallCount: null, // null = جميع الطلبات
            callCountGroups: [], // مجموعات عدد المحاولات المتاحة
        };
    }

    handleDateChange = (e) => {
        this.setState({ postponeDate: e.target.value });
    };

    componentDidMount() {
        this.fetchOrders();
    }

    // جلب الطلبات من API
    fetchOrders = async (status = 'لايرد', page = 1, searchTerm = '') => {
        try {
            this.setState({ loading: true, error: null });

            const encodedStatus = encodeURIComponent(status);
            let url = `${host}users/missmtab3a-orders?status=${encodedStatus}&page=${page}&limit=100&sortBy=call_count&sortOrder=ASC`;

            // إضافة معامل البحث إذا كان موجوداً
            if (searchTerm && searchTerm.trim() !== '') {
                url += `&search=${encodeURIComponent(searchTerm.trim())}`;
            }

            const response = await axios.get(url);
            
            console.log('API Response:', response.data);

            const orders = response.data.orders || [];
            const total = response.data.total || response.data.totalCount || response.data.count || orders.length;

            // حساب مجموعات عدد المحاولات من الطلبات المحملة
            const groupsMap = new Map();
            orders.forEach(order => {
                const callCount = order.call_count || 0;
                if (!groupsMap.has(callCount)) {
                    groupsMap.set(callCount, 0);
                }
                groupsMap.set(callCount, groupsMap.get(callCount) + 1);
            });

            // تحويل الخريطة إلى مصفوفة مرتبة
            const callCountGroups = Array.from(groupsMap.entries())
                .map(([call_count, count]) => ({ call_count, count }))
                .sort((a, b) => a.call_count - b.call_count);

            this.setState({
                allOrders: orders,
                orders: orders,
                filteredOrders: orders,
                loading: false,
                currentStatus: status,
                currentPage: page,
                totalOrders: total,
                callCountGroups: callCountGroups
            }, () => {
                // تطبيق فلتر عدد المحاولات إذا كان محدداً
                if (this.state.selectedCallCount !== null) {
                    this.applyCallCountFilter(this.state.selectedCallCount);
                }
            });

        } catch (error) {
            console.error('Error fetching orders:', error);
            this.setState({
                error: 'حدث خطأ في جلب البيانات',
                loading: false
            });
        }
    };

    // تطبيق فلتر عدد المحاولات محلياً
    applyCallCountFilter = (callCount) => {
        const filtered = callCount === null 
            ? this.state.allOrders 
            : this.state.allOrders.filter(order => order.call_count === callCount);
        
        const totalFiltered = filtered.length;
        const startIndex = (this.state.currentPage - 1) * this.state.itemsPerPage;
        const endIndex = startIndex + this.state.itemsPerPage;
        const paginatedOrders = filtered.slice(startIndex, endIndex);

        this.setState({
            filteredOrders: paginatedOrders,
            totalOrders: totalFiltered,
            selectedCallCount: callCount
        });
    };

    // تغيير مجموعة عدد المحاولات
    handleCallCountChange = (callCount) => {
        this.setState({ currentPage: 1 }, () => {
            this.applyCallCountFilter(callCount);
        });
    };

    // البحث في الطلبات
    handleSearch = (e) => {
        const searchTerm = e.target.value;
        this.setState({ searchTerm, currentPage: 1, selectedCallCount: null });

        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        this.searchTimeout = setTimeout(() => {
            if (searchTerm) {
                // البحث مع API
                this.fetchOrders(this.state.currentStatus, 1, searchTerm);
            } else {
                // إعادة تحميل جميع البيانات
                this.fetchOrders(this.state.currentStatus, 1, '');
            }
        }, 500);
    };

    // التنقل بين الصفحات
    handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= this.getTotalPages()) {
            this.setState({ currentPage: newPage }, () => {
                if (this.state.selectedCallCount !== null) {
                    this.applyCallCountFilter(this.state.selectedCallCount);
                } else if (this.state.searchTerm) {
                    // في حالة البحث، نحتاج لإعادة الطلب من الخادم
                    this.fetchOrders(this.state.currentStatus, newPage, this.state.searchTerm);
                } else {
                    // تطبيق التصفح محلياً
                    const startIndex = (newPage - 1) * this.state.itemsPerPage;
                    const endIndex = startIndex + this.state.itemsPerPage;
                    const paginatedOrders = this.state.allOrders.slice(startIndex, endIndex);
                    
                    this.setState({
                        filteredOrders: paginatedOrders
                    });
                }
            });
        }
    };

    // حساب إجمالي الصفحات
    getTotalPages = () => {
        return Math.ceil(this.state.totalOrders / this.state.itemsPerPage);
    };

    // الحصول على الطلبات للصفحة الحالية
    getCurrentPageOrders = () => {
        return this.state.filteredOrders;
    };

    // إجراء مكالمة
    handleCall = (phoneNumber) => {
        window.open(`tel:${phoneNumber}`);
    };

    // تحويل للواتساب
    handleWhatsApp = (phoneNumber) => {
        let formattedPhone = phoneNumber;
        if (phoneNumber.startsWith('07')) {
            formattedPhone = '964' + phoneNumber.substring(1);
        }
        window.open(`https://wa.me/${formattedPhone}`);
    };

    // فتح مودل المعالجة
    openModal = (orderId) => {
        this.setState({ showModal: true, selectedOrderId: orderId });
    };

    // إغلاق المودل
    closeModal = () => {
        this.setState({
            showModal: false,
            selectedStatus: '',
            postponeDate: '',
            selectedOrderId: null
        });
    };

    // تغيير الحالة المختارة
    handleStatusChange = (status) => {
        this.setState({ selectedStatus: status });
    };

    // الحصول على معلومات الحالة
    getStatusInfo = (status) => {
        const statusMap = {
            'لايرد': { icon: '📞', color: '#ef4444', desc: 'لم يتم الرد على الاتصال' },
            'كاذب': { icon: '❌', color: '#dc2626', desc: 'طلب غير صحيح أو وهمي' },
            'شركة التوصيل': { icon: '🚚', color: '#059669', desc: 'تم التواصل وتحويل للتوصيل' },
            'خطأ بالتجهيز': { icon: '⚠️', color: '#f59e0b', desc: 'خطأ في تجهيز الطلب' },
            'مؤجل': { icon: '📅', color: '#3b82f6', desc: 'تأجيل الطلب لتاريخ لاحق' },
            'تم المعالجة': { icon: '✅', color: '#10b981', desc: 'تم حل الطلب بنجاح' }
        };
        return statusMap[status] || { icon: '📋', color: '#6b7280', desc: status };
    };
    
    formatDateForAPI = (dateString) => {
        try {
            const date = new Date(dateString);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        } catch {
            return dateString;
        }
    };

    // إرسال التحديث
    handleSubmit = async () => {
        try {
            this.setState({ loading: true });

            const requestData = {
                id: this.state.selectedOrderId,
                status: this.state.selectedStatus
            };

            if (this.state.selectedStatus === 'مؤجل' && this.state.postponeDate) {
                requestData.Delayed = this.formatDateForAPI(this.state.postponeDate);
            }

            const response = await axios.post(`${host}users/mtab3a-orders/update/`, requestData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': cookies.get("token")
                }
            });

            alert('تم تحديث الحالة بنجاح');

            this.closeModal();
            // إعادة تحميل البيانات بعد التحديث
            await this.fetchOrders(this.state.currentStatus, 1, this.state.searchTerm);

        } catch (error) {
            console.error('تفاصيل الخطأ:', error);

            let errorMessage = 'حدث خطأ في تحديث الحالة';

            if (error.response) {
                errorMessage = `خطأ من الخادم: ${error.response.status} - ${error.response.data.message || error.response.data}`;
            } else if (error.request) {
                errorMessage = 'لم يتم الحصول على رد من الخادم. تحقق من الاتصال.';
            } else {
                errorMessage = `خطأ في الطلب: ${error.message}`;
            }

            alert(errorMessage);
        } finally {
            this.setState({ loading: false });
        }
    };

    // العودة للصفحة السابقة
    goBack = () => {
        window.history.back();
    };

    // فك ترميز النص العربي
    decodeArabicText = (text) => {
        try {
            return decodeURIComponent(text.replace(/\+/g, ' '));
        } catch {
            return text;
        }
    };

    // تنسيق التاريخ بتوقيت بغداد بدون ثواني
    formatDate = (dateString) => {
        try {
            return moment(dateString)
                .tz('Asia/Baghdad')
                .format('DD/MM/YYYY HH:mm');
        } catch {
            return dateString;
        }
    };

    // تنسيق التاريخ فقط بدون وقت
    formatDateOnly = (dateString) => {
        try {
            return moment(dateString)
                .tz('Asia/Baghdad')
                .format('DD/MM/YYYY');
        } catch {
            return dateString;
        }
    };

    // تنسيق الوقت النسبي
    formatRelativeTime = (dateString) => {
        try {
            const now = moment().tz('Asia/Baghdad');
            const orderTime = moment(dateString).tz('Asia/Baghdad');
            const diffInMinutes = now.diff(orderTime, 'minutes');
            const diffInHours = now.diff(orderTime, 'hours');
            const diffInDays = now.diff(orderTime, 'days');

            if (diffInMinutes < 1) {
                return 'الآن';
            } else if (diffInMinutes < 60) {
                return `مذ ${diffInMinutes} دقيقة`;
            } else if (diffInHours < 24) {
                return `مذ ${diffInHours} ساعة`;
            } else if (diffInDays < 7) {
                return `مذ ${diffInDays} يوم`;
            } else {
                return this.formatDate(dateString);
            }
        } catch {
            return dateString;
        }
    };

    // الحصول على لون الوقت النسبي حسب القدم
    getRelativeTimeColor = (dateString) => {
        try {
            const now = moment().tz('Asia/Baghdad');
            const orderTime = moment(dateString).tz('Asia/Baghdad');
            const diffInMinutes = now.diff(orderTime, 'minutes');
            const diffInHours = now.diff(orderTime, 'hours');
            const diffInDays = now.diff(orderTime, 'days');

            if (diffInMinutes < 5) {
                return { backgroundColor: '#10b981', icon: '🔥' };
            } else if (diffInMinutes < 60) {
                return { backgroundColor: '#3b82f6', icon: '🕒' };
            } else if (diffInHours < 6) {
                return { backgroundColor: '#f59e0b', icon: '⏰' };
            } else if (diffInHours < 24) {
                return { backgroundColor: '#ef4444', icon: '🕐' };
            } else if (diffInDays < 7) {
                return { backgroundColor: '#8b5cf6', icon: '📅' };
            } else {
                return { backgroundColor: '#6b7280', icon: '📋' };
            }
        } catch {
            return { backgroundColor: '#6b7280', icon: '📋' };
        }
    };

    // تحديد لون عداد المحاولات حسب العدد
    getCallCountBadgeColor = (count) => {
        if (count === 0) return {
            backgroundColor: '#6b7280',
            color: 'white',
            borderColor: '#6b7280',
            icon: '🆕'
        };
        if (count <= 2) return {
            backgroundColor: '#22c55e',
            color: 'white',
            borderColor: '#22c55e',
            icon: '✅'
        };
        if (count <= 4) return {
            backgroundColor: '#f59e0b',
            color: 'white',
            borderColor: '#f59e0b',
            icon: '⚠️'
        };
        return {
            backgroundColor: '#ef4444',
            color: 'white',
            borderColor: '#ef4444',
            icon: '🚨'
        };
    };

    render() {
        const {
            searchTerm,
            filteredOrders,
            showModal,
            selectedStatus,
            postponeDate,
            loading,
            error,
            currentPage,
            totalOrders,
            selectedCallCount,
            callCountGroups
        } = this.state;

        const statusOptions = ['لايرد', 'كاذب', 'شركة التوصيل', 'خطأ بالتجهيز', 'مؤجل', 'تم المعالجة'];
        const currentPageOrders = this.getCurrentPageOrders();
        const totalPages = this.getTotalPages();
        const displayedOrdersCount = this.state.totalOrders || this.state.filteredOrders.length;

        const styles = {
            container: {
                minHeight: '100vh',
                backgroundColor: '#f8fafc',
                fontFamily: 'system-ui, -apple-system, sans-serif',
                direction: 'rtl'
            },
            header: {
                backgroundColor: '#ffffff',
                padding: '1rem',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                position: 'sticky',
                top: 0,
                zIndex: 10
            },
            headerContent: {
                maxWidth: '768px',
                margin: '0 auto'
            },
            topRow: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '1rem'
            },
            pageTitle: {
                fontSize: '1.5rem',
                fontWeight: 'bold',
                color: '#1f2937',
                textAlign: 'center',
                flex: 1,
                marginRight: '1rem'
            },
            searchRow: {
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
            },
            searchLabel: {
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151',
                whiteSpace: 'nowrap'
            },
            backButton: {
                padding: '0.75rem',
                backgroundColor: '#e2e8f0',
                border: 'none',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'background-color 0.2s',
                minWidth: '48px',
                height: '48px'
            },
            searchInput: {
                flex: 1,
                padding: '0.75rem',
                border: '1px solid #d1d5db',
                borderRadius: '0.5rem',
                fontSize: '1rem',
                textAlign: 'right'
            },
            content: {
                maxWidth: '768px',
                margin: '0 auto',
                padding: '1rem'
            },
            // Call Count Filter Styles
            callCountFilterContainer: {
                backgroundColor: '#ffffff',
                padding: '1.5rem',
                borderRadius: '1rem',
                marginBottom: '1rem',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                border: '2px solid #e5e7eb'
            },
            callCountFilterTitle: {
                fontSize: '1.1rem',
                fontWeight: '600',
                color: '#1f2937',
                marginBottom: '1rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            },
            callCountButtonsGrid: {
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
                gap: '0.75rem'
            },
            callCountButton: {
                padding: '0.75rem 1rem',
                border: '2px solid #e5e7eb',
                borderRadius: '0.75rem',
                backgroundColor: '#f9fafb',
                cursor: 'pointer',
                transition: 'all 0.3s',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '0.5rem',
                minHeight: '80px',
                justifyContent: 'center'
            },
            callCountButtonActive: {
                backgroundColor: '#3b82f6',
                color: 'white',
                borderColor: '#3b82f6',
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 12px rgba(59, 130, 246, 0.4)'
            },
            callCountNumber: {
                fontSize: '1.5rem',
                fontWeight: 'bold'
            },
            callCountLabel: {
                fontSize: '0.875rem',
                opacity: 0.8
            },
            callCountCount: {
                fontSize: '0.75rem',
                backgroundColor: 'rgba(0,0,0,0.1)',
                padding: '0.25rem 0.5rem',
                borderRadius: '1rem'
            },
            statsRow: {
                backgroundColor: '#ffffff',
                padding: '1rem 1.5rem',
                borderRadius: '1rem',
                marginBottom: '1rem',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                border: '2px solid #3b82f6'
            },
            statsText: {
                fontSize: '1.1rem',
                fontWeight: '600',
                color: '#1f2937',
                textAlign: 'center'
            },
            loading: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '200px',
                flexDirection: 'column',
                gap: '1rem'
            },
            error: {
                backgroundColor: '#fee2e2',
                color: '#dc2626',
                padding: '1rem',
                borderRadius: '0.5rem',
                textAlign: 'center'
            },
            orderCard: {
                backgroundColor: '#ffffff',
                borderRadius: '1rem',
                padding: '1.5rem',
                marginBottom: '1rem',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                border: '1px solid #e5e7eb'
            },
            orderHeader: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1rem',
                paddingBottom: '1rem',
                borderBottom: '1px solid #e5e7eb',
                flexWrap: 'wrap',
                gap: '0.5rem'
            },
            orderNumber: {
                fontSize: '1.25rem',
                fontWeight: 'bold',
                color: '#1f2937'
            },
            orderHeaderRight: {
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                flexWrap: 'wrap'
            },
            price: {
                fontSize: '1.25rem',
                fontWeight: 'bold',
                color: '#059669'
            },
            callCountBadge: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.5rem 1rem',
                borderRadius: '2rem',
                fontSize: '0.875rem',
                fontWeight: 'bold',
                minWidth: 'fit-content'
            },
            section: {
                marginBottom: '1.5rem'
            },
            sectionTitle: {
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '0.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            },
            customerInfo: {
                backgroundColor: '#f9fafb',
                padding: '1rem',
                borderRadius: '0.5rem',
                marginBottom: '1rem'
            },
            phoneButtons: {
                display: 'flex',
                gap: '0.5rem',
                marginTop: '0.5rem'
            },
            phoneButton: {
                padding: '0.5rem 1rem',
                border: 'none',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                fontSize: '0.875rem',
                fontWeight: '500'
            },
            callButton: {
                backgroundColor: '#10b981',
                color: 'white'
            },
            whatsappButton: {
                backgroundColor: '#25d366',
                color: 'white'
            },
            itemsList: {
                backgroundColor: '#f0f9ff',
                padding: '1.5rem',
                borderRadius: '0.75rem',
                border: '2px solid #0ea5e9',
                boxShadow: '0 2px 8px rgba(14, 165, 233, 0.1)'
            },
            item: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '1rem',
                marginBottom: '0.5rem',
                backgroundColor: '#ffffff',
                borderRadius: '0.5rem',
                borderRight: '4px solid #0ea5e9',
                boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                fontSize: '1rem',
                fontWeight: '500'
            },
            historyItem: {
                backgroundColor: '#f3f4f6',
                padding: '0.75rem',
                borderRadius: '0.5rem',
                marginBottom: '0.5rem',
                borderRight: '4px solid #3b82f6'
            },
            processButton: {
                width: '100%',
                padding: '1rem',
                backgroundColor: '#3b82f6',
                color: 'white',
                border: 'none',
                borderRadius: '0.5rem',
                fontSize: '1.1rem',
                fontWeight: '600',
                cursor: 'pointer',
                marginTop: '1rem'
            },
            deliveryCompanySection: {
                backgroundColor: '#f0fdf4',
                padding: '1.25rem',
                borderRadius: '0.75rem',
                border: '2px solid #22c55e',
                boxShadow: '0 2px 8px rgba(34, 197, 94, 0.1)'
            },
            deliveryCompanyTitle: {
                fontSize: '1.1rem',
                fontWeight: 'bold',
                color: '#15803d',
                marginBottom: '0.75rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            },
            deliveryCompanyName: {
                fontSize: '1.2rem',
                fontWeight: 'bold',
                color: '#166534',
                backgroundColor: '#dcfce7',
                padding: '0.75rem 1rem',
                borderRadius: '0.5rem',
                textAlign: 'center',
                border: '1px solid #22c55e'
            },
            deliveryDate: {
                fontSize: '0.95rem',
                color: '#374151',
                marginTop: '0.5rem',
                textAlign: 'center'
            },
            paginationContainer: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '1rem',
                margin: '2rem 0',
                padding: '1rem',
                backgroundColor: '#ffffff',
                borderRadius: '1rem',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            },
            paginationButton: {
                padding: '0.5rem 1rem',
                border: '1px solid #d1d5db',
                borderRadius: '0.5rem',
                backgroundColor: '#ffffff',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                transition: 'all 0.2s'
            },
            paginationButtonDisabled: {
                opacity: 0.5,
                cursor: 'not-allowed'
            },
            paginationInfo: {
                fontSize: '1rem',
                fontWeight: '500',
                color: '#374151'
            },
            modal: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
                padding: '1rem'
            },
            modalContent: {
                backgroundColor: 'white',
                borderRadius: '1rem',
                padding: '2rem',
                maxWidth: '400px',
                width: '100%',
                maxHeight: '80vh',
                overflowY: 'auto'
            },
            modalTitle: {
                fontSize: '1.25rem',
                fontWeight: 'bold',
                marginBottom: '1rem',
                textAlign: 'center',
                color: '#1f2937'
            },
            statusOption: {
                padding: '1rem 1.5rem',
                margin: '0.5rem 0',
                border: '2px solid #e5e7eb',
                borderRadius: '0.75rem',
                cursor: 'pointer',
                textAlign: 'center',
                transition: 'all 0.3s',
                fontSize: '1rem',
                fontWeight: '600',
                backgroundColor: '#f9fafb',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.75rem'
            },
            statusOptionSelected: {
                backgroundColor: '#3b82f6',
                color: 'white',
                borderColor: '#3b82f6',
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 12px rgba(59, 130, 246, 0.4)'
            },
            statusIcon: {
                fontSize: '1.2rem'
            },
            dateInput: {
                width: '100%',
                padding: '0.75rem',
                border: '1px solid #d1d5db',
                borderRadius: '0.5rem',
                marginTop: '1rem'
            },
            modalButtons: {
                display: 'flex',
                gap: '0.5rem',
                marginTop: '1.5rem'
            },
            modalButton: {
                flex: 1,
                padding: '0.75rem',
                border: 'none',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                fontWeight: '600'
            },
            submitButton: {
                backgroundColor: '#10b981',
                color: 'white'
            },
            cancelButton: {
                backgroundColor: '#6b7280',
                color: 'white'
            },
            noData: {
                textAlign: 'center',
                padding: '2rem',
                color: '#6b7280'
            }
        };

        if (loading) {
            return (
                <div style={styles.container}>
                    <div style={styles.content}>
                        <div style={styles.loading}>
                            <Loader className="animate-spin" size={40} />
                            <p>جاري تحميل الطلبات...</p>
                        </div>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div style={styles.container}>
                    <div style={styles.content}>
                        <div style={styles.error}>
                            {error}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div style={styles.container}>
                {/* Header */}
                <div style={styles.header}>
                    <div style={styles.headerContent}>
                        <div style={styles.topRow}>
                            <button style={styles.backButton} onClick={this.goBack}>
                                <ArrowLeft size={24} />
                            </button>
                            <div style={styles.pageTitle}>الطلبات لايرد</div>
                        </div>
                        <div style={styles.searchRow}>
                            <div style={styles.searchLabel}>البحث عن طلب:</div>
                            <input
                                type="text"
                                placeholder="ابحث برقم الطلب أو رقم الهاتف..."
                                value={searchTerm}
                                onChange={this.handleSearch}
                                style={styles.searchInput}
                            />
                        </div>
                    </div>
                </div>

                {/* Content */}
                <div style={styles.content}>
                    {/* Call Count Filter */}
                    <div style={styles.callCountFilterContainer}>
                        <div style={styles.callCountFilterTitle}>
                            <Filter size={20} />
                            فلترة حسب عدد المحاولات
                        </div>
                        <div style={styles.callCountButtonsGrid}>
                            {/* زر "جميع الطلبات" */}
                            <button
                                style={{
                                    ...styles.callCountButton,
                                    ...(selectedCallCount === null ? styles.callCountButtonActive : {})
                                }}
                                onClick={() => this.handleCallCountChange(null)}
                            >
                                <div style={styles.callCountNumber}>الكل</div>
                                <div style={styles.callCountLabel}>جميع الطلبات</div>
                                <div style={styles.callCountCount}>{this.state.allOrders.length} طلب</div>
                            </button>

                            {/* أزرار المجموعات */}
                            {callCountGroups.map(group => {
                                const badgeColor = this.getCallCountBadgeColor(group.call_count);
                                return (
                                    <button
                                        key={group.call_count}
                                        style={{
                                            ...styles.callCountButton,
                                            ...(selectedCallCount === group.call_count ? styles.callCountButtonActive : {})
                                        }}
                                        onClick={() => this.handleCallCountChange(group.call_count)}
                                    >
                                        <div style={styles.callCountNumber}>
                                            {badgeColor.icon} {group.call_count}
                                        </div>
                                        <div style={styles.callCountLabel}>محاولة</div>
                                        <div style={styles.callCountCount}>{group.count} طلب</div>
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    {/* Stats Row */}
                    {!loading && (
                        <div style={styles.statsRow}>
                            <div style={styles.statsText}>
                                📊 عدد الطلبات المعروضة: <strong style={{ color: '#059669' }}>{displayedOrdersCount.toLocaleString()}</strong> طلب
                                {selectedCallCount !== null && (
                                    <span style={{ color: '#f59e0b', marginRight: '1rem' }}>
                                        🎯 (عدد المحاولات: {selectedCallCount})
                                    </span>
                                )}
                                {searchTerm && (
                                    <span style={{ color: '#f59e0b', marginRight: '1rem' }}>
                                        🔍 (نتائج البحث عن: "{searchTerm}")
                                    </span>
                                )}
                                <br />
                                <span style={{ fontSize: '0.9rem', color: '#6b7280', marginTop: '0.5rem', display: 'inline-block' }}>
                                    📄 عرض <strong>{currentPageOrders.length}</strong> من <strong>{this.state.itemsPerPage}</strong> طلب في الصفحة <strong>{currentPage}</strong> من <strong>{totalPages || 1}</strong>
                                </span>
                            </div>
                        </div>
                    )}

                    {currentPageOrders.length === 0 ? (
                        <div style={{
                            ...styles.noData,
                            backgroundColor: '#fef3c7',
                            padding: '2rem',
                            borderRadius: '1rem',
                            border: '2px solid #f59e0b'
                        }}>
                            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📋</div>
                            <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#92400e', marginBottom: '0.5rem' }}>
                                لا توجد طلبات متطابقة
                            </div>
                            <div style={{ color: '#6b7280' }}>
                                {searchTerm ? 
                                    `لم يتم العثور على طلبات تحتوي على "${searchTerm}"` : 
                                    selectedCallCount !== null ? 
                                        `لا توجد طلبات بعدد محاولات ${selectedCallCount}` :
                                        'لا توجد طلبات في هذه الحالة حالياً'
                                }
                            </div>
                        </div>
                    ) : (
                        <>
                            {currentPageOrders.map(order => (
                                <div key={order.id} style={styles.orderCard}>
                                    {/* Order Header */}
                                    <div style={styles.orderHeader}>
                                        <div style={styles.orderNumber}>طلب رقم: {order.id}</div>
                                        <div style={styles.orderHeaderRight}>
                                            <div
                                                style={{
                                                    ...styles.callCountBadge,
                                                    ...this.getCallCountBadgeColor(order.call_count || 0)
                                                }}
                                            >
                                                <Phone size={16} />
                                                محاولات الاتصال: {order.call_count || 0}
                                            </div>
                                            <div style={styles.price}>{order.price.toLocaleString()} د.ع</div>
                                        </div>
                                    </div>

                                    {/* Customer Info */}
                                    <div style={styles.section}>
                                        <div style={styles.sectionTitle}>
                                            <User size={20} />
                                            معلومات الزبون
                                        </div>
                                        <div style={styles.customerInfo}>
                                            <div><strong>الاسم:</strong> {this.decodeArabicText(order.name) || 'غير محدد'}</div>
                                            <div><strong>الهاتف:</strong> {order.phone}</div>
                                            <div style={styles.phoneButtons}>
                                                <button
                                                    style={{ ...styles.phoneButton, ...styles.callButton }}
                                                    onClick={() => this.handleCall(order.phone)}
                                                >
                                                    <Phone size={16} />
                                                    اتصال
                                                </button>
                                                <button
                                                    style={{ ...styles.phoneButton, ...styles.whatsappButton }}
                                                    onClick={() => this.handleWhatsApp(order.phone)}
                                                >
                                                    <MessageSquare size={16} />
                                                    واتساب
                                                </button>
                                            </div>
                                            <div style={{ marginTop: '0.5rem' }}>
                                                <strong>العنوان:</strong> {this.decodeArabicText(order.government)} - {this.decodeArabicText(order.city)}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Delivery Company - Enhanced */}
                                    {order.printerOrders && order.printerOrders.length > 0 && (
                                        <div style={styles.section}>
                                            <div style={styles.deliveryCompanySection}>
                                                <div style={styles.deliveryCompanyTitle}>
                                                    <Building2 size={20} />
                                                    شركة التوصيل
                                                </div>
                                                <div style={styles.deliveryCompanyName}>
                                                    {this.decodeArabicText(order.printerOrders[0].prints.name)}
                                                </div>
                                                <div style={styles.deliveryDate}>
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        gap: '0.5rem',
                                                        flexWrap: 'wrap'
                                                    }}>
                                                        <strong>تاريخ ترحيل الطلب:</strong>
                                                        {(() => {
                                                            const timeColor = this.getRelativeTimeColor(order.printerOrders[0].prints.createdAt);
                                                            return (
                                                                <span style={{
                                                                    backgroundColor: timeColor.backgroundColor,
                                                                    color: 'white',
                                                                    padding: '0.3rem 0.6rem',
                                                                    borderRadius: '1rem',
                                                                    fontSize: '0.8rem',
                                                                    fontWeight: '600',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '0.25rem'
                                                                }}>
                                                                    {timeColor.icon} {this.formatRelativeTime(order.printerOrders[0].prints.createdAt)}
                                                                </span>
                                                            );
                                                        })()}
                                                    </div>
                                                    <div style={{ 
                                                        fontSize: '0.8rem', 
                                                        color: '#6b7280',
                                                        marginTop: '0.25rem'
                                                    }}>
                                                        ({this.formatDateOnly(order.printerOrders[0].prints.createdAt)})
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Items */}
                                    <div style={styles.section}>
                                        <div style={styles.sectionTitle}>
                                            <Package size={20} />
                                            مواد الطلب
                                        </div>
                                        <div style={styles.itemsList}>
                                            {order.ordersFormItems && order.ordersFormItems.map((item, index) => (
                                                <div key={index} style={styles.item}>
                                                    <span>{this.decodeArabicText(item.components.name)}</span>
                                                    <span><strong>العدد: {item.count}</strong></span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Notes */}
                                    {order.notes && (
                                        <div style={styles.section}>
                                            <div style={styles.sectionTitle}>
                                                <FileText size={20} />
                                                ملاحظات
                                            </div>
                                            <div style={{ backgroundColor: '#fef3c7', padding: '0.75rem', borderRadius: '0.5rem' }}>
                                                {this.decodeArabicText(order.notes)}
                                            </div>
                                        </div>
                                    )}

                                    {/* History */}
                                    {order.matab3alogs && order.matab3alogs.length > 0 && (
                                        <div style={styles.section}>
                                            <div style={styles.sectionTitle}>
                                                <Clock size={20} />
                                                سجل المتابعة
                                            </div>
                                            {order.matab3alogs.map((log, index) => {
                                                const timeColor = this.getRelativeTimeColor(log.updatedAt);
                                                return (
                                                    <div key={index} style={styles.historyItem}>
                                                        <div><strong>{this.decodeArabicText(log.user.name)}</strong> - {this.decodeArabicText(log.status)}</div>
                                                        <div style={{ 
                                                            fontSize: '0.875rem', 
                                                            color: '#6b7280', 
                                                            marginTop: '0.25rem',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '0.5rem'
                                                        }}>
                                                            <span style={{
                                                                backgroundColor: timeColor.backgroundColor,
                                                                color: 'white',
                                                                padding: '0.2rem 0.5rem',
                                                                borderRadius: '1rem',
                                                                fontSize: '0.75rem',
                                                                fontWeight: '600',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '0.25rem'
                                                            }}>
                                                                {timeColor.icon} {this.formatRelativeTime(log.updatedAt)}
                                                            </span>
                                                            <span style={{ opacity: 0.6 }}>
                                                                ({this.formatDate(log.updatedAt)})
                                                            </span>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}

                                    {/* Order Info */}
                                    <div style={styles.section}>
                                        <div style={styles.sectionTitle}>
                                            <Building2 size={20} />
                                            معلومات إضافية
                                        </div>
                                        <div style={styles.customerInfo}>
                                            <div><strong>مثبت الطلب:</strong> {this.decodeArabicText(order.user.name)}</div>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.5rem',
                                                marginTop: '0.5rem'
                                            }}>
                                                <strong>الحالة الحالية:</strong>
                                                <span style={{
                                                    padding: '0.25rem 0.75rem',
                                                    borderRadius: '1rem',
                                                    fontSize: '0.875rem',
                                                    fontWeight: 'bold',
                                                    backgroundColor: this.getStatusInfo(order.calls).color,
                                                    color: 'white'
                                                }}>
                                                    {this.getStatusInfo(order.calls).icon} {this.decodeArabicText(order.calls)}
                                                </span>
                                            </div>
                                            <div style={{
                                                marginTop: '0.5rem',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.5rem',
                                                flexWrap: 'wrap'
                                            }}>
                                                <strong>آخر تحديث:</strong>
                                                {(() => {
                                                    const timeColor = this.getRelativeTimeColor(order.updatedAt);
                                                    return (
                                                        <span style={{
                                                            backgroundColor: timeColor.backgroundColor,
                                                            color: 'white',
                                                            padding: '0.3rem 0.6rem',
                                                            borderRadius: '1rem',
                                                            fontSize: '0.8rem',
                                                            fontWeight: '600',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '0.25rem'
                                                        }}>
                                                            {timeColor.icon} {this.formatRelativeTime(order.updatedAt)}
                                                        </span>
                                                    );
                                                })()}
                                                <span style={{ 
                                                    fontSize: '0.8rem', 
                                                    color: '#6b7280' 
                                                }}>
                                                    ({this.formatDate(order.updatedAt)})
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Process Button */}
                                    <button
                                        style={{
                                            ...styles.processButton,
                                            background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                                            boxShadow: '0 4px 15px rgba(59, 130, 246, 0.4)',
                                            border: 'none',
                                            transform: 'translateY(0)',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onClick={() => this.openModal(order.id)}
                                        onMouseEnter={(e) => {
                                            e.target.style.transform = 'translateY(-2px)';
                                            e.target.style.boxShadow = '0 6px 20px rgba(59, 130, 246, 0.6)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.transform = 'translateY(0)';
                                            e.target.style.boxShadow = '0 4px 15px rgba(59, 130, 246, 0.4)';
                                        }}
                                    >
                                        🔄 معالجة الطلب
                                    </button>
                                </div>
                            ))}

                            {/* Pagination */}
                            {totalPages > 1 && (
                                <div style={styles.paginationContainer}>
                                    <button
                                        style={{
                                            ...styles.paginationButton,
                                            ...(currentPage === 1 ? styles.paginationButtonDisabled : {})
                                        }}
                                        onClick={() => this.handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        <ChevronRight size={16} />
                                        السابق
                                    </button>

                                    <div style={styles.paginationInfo}>
                                        صفحة {currentPage} من {totalPages}
                                    </div>

                                    <button
                                        style={{
                                            ...styles.paginationButton,
                                            ...(currentPage === totalPages ? styles.paginationButtonDisabled : {})
                                        }}
                                        onClick={() => this.handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        التالي
                                        <ChevronLeft size={16} />
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </div>

                {/* Modal */}
                {showModal && (
                    <div style={styles.modal}>
                        <div style={styles.modalContent}>
                            <div style={styles.modalTitle}>
                                🔄 تحديث حالة الطلب
                            </div>

                            {statusOptions.map(status => {
                                const statusInfo = this.getStatusInfo(status);
                                const isSelected = selectedStatus === status;

                                return (
                                    <div
                                        key={status}
                                        style={{
                                            ...styles.statusOption,
                                            ...(isSelected ? styles.statusOptionSelected : {}),
                                            borderColor: isSelected ? statusInfo.color : '#e5e7eb'
                                        }}
                                        onClick={() => this.handleStatusChange(status)}
                                    >
                                        <span style={styles.statusIcon}>{statusInfo.icon}</span>
                                        <div>
                                            <div style={{ fontWeight: 'bold' }}>{status}</div>
                                            <div style={{
                                                fontSize: '0.8rem',
                                                opacity: 0.8,
                                                marginTop: '0.25rem'
                                            }}>
                                                {statusInfo.desc}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}

                            {selectedStatus === 'مؤجل' && (
                                <input
                                    type="date"
                                    value={postponeDate}
                                    onChange={this.handleDateChange}
                                    style={styles.dateInput}
                                    placeholder="تاريخ التأجيل"
                                />
                            )}

                            <div style={styles.modalButtons}>
                                <button
                                    style={{ ...styles.modalButton, ...styles.submitButton }}
                                    onClick={this.handleSubmit}
                                    disabled={!selectedStatus || (selectedStatus === 'مؤجل' && !postponeDate)}
                                >
                                    ✅ تأكيد التحديث
                                </button>
                                <button
                                    style={{ ...styles.modalButton, ...styles.cancelButton }}
                                    onClick={this.closeModal}
                                >
                                    ❌ إلغاء
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default OrderDetailsPage;